/**
 * @generated SignedSource<<9d8b02bc8b8d35073ae46e58998e2fe3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteRowInput = {
  clientMutationId?: string | null;
  rowId: string;
};
export type Row_DeleteRow_Mutation$variables = {
  input: DeleteRowInput;
};
export type Row_DeleteRow_Mutation$data = {
  readonly deleteRow: {
    readonly element: {
      readonly id: string;
      readonly rows: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly text: string;
          } | null;
        } | null>;
      };
    } | null;
  } | null;
};
export type Row_DeleteRow_Mutation = {
  response: Row_DeleteRow_Mutation$data;
  variables: Row_DeleteRow_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteRowPayload",
    "kind": "LinkedField",
    "name": "deleteRow",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ElementNode",
        "kind": "LinkedField",
        "name": "element",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RowNodeConnection",
            "kind": "LinkedField",
            "name": "rows",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RowNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RowNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "text",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Row_DeleteRow_Mutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Row_DeleteRow_Mutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "3075e7bd51339232930be0fdcf8165cd",
    "id": null,
    "metadata": {},
    "name": "Row_DeleteRow_Mutation",
    "operationKind": "mutation",
    "text": "mutation Row_DeleteRow_Mutation(\n  $input: DeleteRowInput!\n) {\n  deleteRow(input: $input) {\n    element {\n      id\n      rows {\n        edges {\n          node {\n            id\n            text\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5daab3051fe9c362a1bf99f77907019f";

export default node;
